<a [routerLink]="route" class="sidebar-link" routerLinkActive="sidebar-link--selected">
  <span id="{{id}}">
    <ng-content></ng-content>
  </span>
</a>
